

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";
  import {ILocker2} from "@/model/Locker/lockerInterfaces";
  import {IOnOffHandlers} from "bonomo";
  import {namespace} from "vuex-class";
  import {EPermissionActions} from "@/model/EPermissionActions";
  import {SCREEN_TYPE_PRESETS} from "@/constants/locker";

  const locker2Module = namespace("locker2Module");

  @Component
  export default class LScreenType extends Vue {

    @locker2Module.Action('setScreenType')
    setScreenType!: (data: { lockerId: number, orientation: string, resolution: string }) => void;

    @Prop()
    locker!: ILocker2;
    @Prop()
    disabled!: boolean;
    @Prop()
    editing!: boolean;

    loading: boolean = false;
    submitting: boolean = false;
    subscribes: IOnOffHandlers = {};
    screenType: string = '';

    get canEdit(): boolean {
      return this.$canAction(EPermissionActions.ACTION_LOCKERS_UPDATE);
    }

    get items(): any[] {
      return Object.keys(SCREEN_TYPE_PRESETS)
        .map((key) => ({
          text: `${this.$t('lockers.locker.fields.screen_type.values.' + key)} (${SCREEN_TYPE_PRESETS[key].resolution})`,
          value: key
        }));
    }

    created() {
      this.subscribes = this.$ons({
        'backend.call.OK.locker2Loaded': this.onLockerLoaded,
        'backend.call.OK.lockerScreenConfigSet': this.onOK,
        'backend.call.KO.lockerScreenConfigSet': this.onKO,
      });
      if (this.locker) {
        this.onLockerLoaded();
      }
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    onCancel() {
      this.onLockerLoaded();
      this.stopEditing();
    }

    onEdit() {
      this.$emit('update:editing', true);
    }

    onKO() {
      this.submitting = false;
    }

    onLockerLoaded() {
      const config = this.locker.screenConfig;
      const matchingKey = Object.keys(SCREEN_TYPE_PRESETS).find((key) => (
        !!config &&
        SCREEN_TYPE_PRESETS[key].orientation === config.orientation &&
        SCREEN_TYPE_PRESETS[key].resolution === config.resolution
      ));
      this.screenType = matchingKey || '';
    }

    onOK() {
      this.stopEditing();
      this.submitting = false;
      this.$uiBus.emit('success', 'OK');
    }

    onSave() {
      const preset = SCREEN_TYPE_PRESETS[this.screenType];
      if (preset) {
        this.setScreenType({
          lockerId: this.locker.id,
          orientation: preset.orientation,
          resolution: preset.resolution,
        });
      }
      else {
        this.stopEditing();
      }
    }

    stopEditing() {
      this.$emit('update:editing', false);
    }

  }

